import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  DateField,
  FunctionField,
  usePermissions,
} from "react-admin";
import { Typography, Divider } from "@mui/material";

export const FeedbackSubmissionShow = () => {
  const { permissions = [] } = usePermissions();

  const canRead =
    permissions.includes("forms.read") ||
    permissions.includes("forms.*") ||
    permissions.includes("*");

  if (!canRead) return null;

  return (
    <Show>
      <SimpleShowLayout>
        <Typography variant="h6">Response Info</Typography>

        <NumberField source="id" />
        <TextField source="form_title" label="Form" />
        <TextField source="feedback_type_name" label="Form Type" />
        <TextField source="email" />
        <DateField source="submitted_at" showTime />

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6">Questions</Typography>

        <FunctionField
          render={(record) => {
            if (!record?.labeled_answers?.length) {
              return <span>No answers available</span>;
            }

            return (
              <div>
                {record.labeled_answers.map((item, index) => (
                  <div key={index} style={{ marginBottom: 12 }}>
                    <strong>{item.question}</strong>
                    <div>
                      {Array.isArray(item.answer)
                        ? item.answer.join(", ")
                        : String(item.answer)}
                    </div>
                  </div>
                ))}
              </div>
            );
          }}
        />
      </SimpleShowLayout>
    </Show>
  );
};